import React, { useEffect, useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
const DISMISS_KEY = 'dermalipo:cherry-floater-dismissed';
export function CherryFloater() {
  const {
    t
  } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Session-level dismiss memory
    if (sessionStorage.getItem(DISMISS_KEY) === '1') {
      setIsDismissed(true);
      return;
    }
    const handleScroll = () => {
      const contact = document.getElementById('contacto');
      const scrollY = window.scrollY;
      const showAfter = 800;
      const hideBefore = contact ? contact.offsetTop - 400 : Infinity;
      setIsVisible(scrollY > showAfter && scrollY < hideBefore);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCalculator = () => {
    document.getElementById('financiamiento')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const dismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    sessionStorage.setItem(DISMISS_KEY, '1');
    setIsDismissed(true);
  };
  if (isDismissed) return null;
  return <AnimatePresence data-id="element-310">
      {isVisible && <motion.div initial={{
      x: 60,
      opacity: 0,
      scale: 0.95
    }} animate={{
      x: 0,
      opacity: 1,
      scale: 1
    }} exit={{
      x: 60,
      opacity: 0,
      scale: 0.95
    }} transition={{
      duration: 0.6,
      ease: [0.33, 1, 0.68, 1]
    }} className="hidden lg:block fixed bottom-8 right-8 z-40" data-id="element-311">
          {/* Pulsing glow ring — calls attention */}
          <motion.div className="absolute inset-0 rounded-2xl bg-brand-gold/30 -z-10" animate={{
        scale: [1, 1.08, 1],
        opacity: [0.4, 0.15, 0.4]
      }} transition={{
        duration: 2.4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-312" />

          <button onClick={scrollToCalculator} className="relative group bg-brand-dark/95 backdrop-blur-md border border-brand-gold/40 rounded-2xl shadow-2xl px-5 py-4 flex items-center gap-4 hover:bg-brand-dark hover:border-brand-gold transition-all duration-300 cursor-pointer" aria-label={t('cherry.floaterAriaLabel')} data-id="element-313">
            {/* Percent icon — Cherry's signature mark */}
            <div className="relative w-11 h-11 rounded-full bg-brand-gold flex items-center justify-center shrink-0" data-id="element-314">
              <span className="font-serif text-brand-dark text-xl font-bold leading-none" data-id="element-315">
                %
              </span>
              {/* Tiny ping dot for attention */}
              <span className="absolute -top-1 -right-1 flex h-3 w-3" data-id="element-316">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-gold opacity-75" data-id="element-317"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-brand-gold border-2 border-brand-dark" data-id="element-318"></span>
              </span>
            </div>

            {/* Text */}
            <div className="text-left pr-2" data-id="element-319">
              <p className="text-brand-gold font-medium tracking-[0.15em] text-[9px] uppercase mb-0.5" data-id="element-320">
                {t('cherry.floaterEyebrow')}
              </p>
              <p className="text-brand-cream font-serif text-lg font-light leading-tight" data-id="element-321">
                {t('cherry.floaterTitle')}
              </p>
              <p className="text-brand-cream/60 text-[11px] font-light mt-0.5 group-hover:text-brand-cream/90 transition-colors" data-id="element-322">
                {t('cherry.floaterCta')} →
              </p>
            </div>
          </button>

          {/* Dismiss button */}
          <button onClick={dismiss} className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-brand-cream text-brand-dark flex items-center justify-center shadow-md hover:bg-brand-gold transition-colors" aria-label="Close" data-id="element-323">
            <XIcon className="w-3 h-3" strokeWidth={2} data-id="element-324" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}